import debounce from 'lodash/debounce'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setApplicationWidth } from '~/actions/application'
import useWindowWidth from '~/hooks/windowWidth'

export default () => {
  const dispatch = useDispatch()
  const windowInnerWidth = useWindowWidth()
  const resizeWindow = useCallback(
    debounce((width) => dispatch(() => setApplicationWidth(width)), 200),
    [],
  )

  useEffect(() => {
    resizeWindow(windowInnerWidth)
  }, [windowInnerWidth])
}
